import gql from 'graphql-tag';

const enrollMember = gql`
mutation enrollMember($member: MemberInput) {
  enrollMember(input: $member) {
    id
    personId
    firstName
    middleName
    lastName
    phoneNumber
    addressLine1
    addressLine2
    city
    state
    zipCode
    country
    emailAddress
    birthMonth
    birthDay
    birthYear
    spouseFirstName
    spouseMiddleName
    spouseLastName
    spouseBirthMonth
    spouseBirthDay
    spouseBirthYear
    spouseEmailAddress
    spouseId
    spanishMaterial
    accountIndicator
    accountType
    accountStatus
    expiryDate
    autoRenew
    membershipTerm
    cardSentDate
  }
}
`;

export default enrollMember;



// WEBPACK FOOTER //
// ./src/app/mutations/enrollMember.js